import React from 'react';
import { observer } from '../../shared/observer';

// «На этом адресе у вас N бутылей, всего в залоге M» — складской залог тары.
// Показывается отдельно от переключателя способов: сервер вычитает залог из
// потребности, поэтому при достаточном количестве тары выбор способа вообще
// скрывается, а объяснить клиенту, почему тару не предлагают, всё равно нужно.
//
// tare_balance приходит из MobileCartV3Serializer и равен нулям, если у
// компании выключен складской учёт тары — тогда компонент ничего не рисует.
export function tarePlural(n) {
  const t = n % 10;
  const h = n % 100;
  let word = 'бутылей';
  if (t === 1 && h !== 11) word = 'бутыль';
  else if (t >= 2 && t <= 4 && (h < 12 || h > 14)) word = 'бутыли';
  return `${n} ${word}`;
}

class TareBalanceNoteView extends React.Component {
  render() {
    const bal = (this.props.cart.cart.tare_balance) || {};
    const addr = bal.address || 0;
    const total = bal.total || 0;
    if (!addr && !total) return null;

    let text;
    if (addr > 0) {
      // Общий остаток дописываем, только когда он больше адресного, иначе
      // строка повторила бы одно и то же число дважды.
      const parts = [`На этом адресе у вас ${tarePlural(addr)}`];
      if (total > addr) parts.push(`всего в залоге ${tarePlural(total)}`);
      text = parts.join(', ');
    } else {
      // По адресу тары нет (или адрес заказа ещё не выбран) — «на этом адресе
      // у вас 0 бутылей» только путает, показываем общий залог по клиенту.
      // Сервер в этом случае тоже считает потребность от общего остатка
      // (Website::Cart#held_tare_count).
      text = `У вас в залоге ${tarePlural(total)}`;
    }

    return (
      <p className="ng-tare-balance">{text}.</p>
    );
  }
}

export const TareBalanceNote = observer(TareBalanceNoteView, ['cartStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/TareBalanceNote.jsx